// Iter 129 — Sidebar dual-office clock strip.
//
// A tiny vertical "London · Colombo" clock display sitting between the
// "My timesheet" link and today's date in the sidebar. Ticks every
// 30 s. Kept intentionally compact — the full detailed strip lives on
// the Today / Rota / Timesheet pages via <OfficeTimeStrip>.
import { useEffect, useState } from "react";
import { LIVE_OFFICES, OFFICE_LABEL, nowHHMMInOffice, zoneAbbr } from "@/lib/officeTime";
import { useAuth } from "@/contexts/AuthContext";

export default function SidebarClocks() {
  const { user } = useAuth();
  const [tick, setTick] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setTick(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);
  const mine = user?.office || null;
  return (
    <div
      className="px-2 flex flex-col gap-0.5 text-[10px] tabular-nums"
      data-testid="sidebar-office-clocks"
    >
      {LIVE_OFFICES.map((o) => {
        const isMine = mine === o;
        return (
          <div
            key={o}
            className={`flex items-center gap-1.5 ${isMine ? "text-slate-900 font-semibold" : "text-slate-500"}`}
            data-testid={`sidebar-clock-${o.replace(/\s+/g, "-").toLowerCase()}`}
            title={isMine ? "Your office" : `${OFFICE_LABEL[o]} office`}
          >
            <span className="w-1 h-1 rounded-full bg-slate-400 shrink-0"/>
            <span className="w-[46px]">{OFFICE_LABEL[o]}</span>
            <span className="text-slate-900">{nowHHMMInOffice(o, tick)}</span>
            <span className="text-slate-400 text-[9px] uppercase tracking-wider">
              {zoneAbbr(o, tick)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
